export enum PropertyTabs {
  OWNERS = 'OWNERS',
  PROGRESS = 'PROGRESS',
  BIDDING = 'BIDDING',
  DOCUMENTS = 'DOCUMENTS',
  PICTURES = 'PICTURES',
  ORDERS = 'ORDERS',
}
